import { defineComponent, computed } from "vue";
import PtButton from "@com/pt-components/pt-button/index.vue";
import { PtButtonType, PtButtonTheme } from "@com/pt-components/pt-button/enum";
// import { language } from '@/common/storage'
import { t } from "@/lang";
import { getRouteHelperUrlByDomain } from "@com/utils/helper";
import { isCNSuffix } from "@com/utils/url";
export default defineComponent({
    props: {
        // 主标题
        title: {
            type: String,
            default: t("playTurbo.common.pushInfoConfirm.title")
        },
        // 副标题
        subtitle: {
            type: String,
            default: ""
        },
        // 弹窗显隐
        visible: {
            type: Boolean,
            default: false
        },
        // 是否隐藏取消按钮
        hideCancel: {
            type: Boolean,
            default: false
        },
        // 确认按钮文案
        submitTitle: {
            type: String,
            default: ""
        }
    },
    components: {
        PtButton: PtButton
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var handleToPage = function() {
            var url = isCNSuffix() ? getRouteHelperUrlByDomain("cn", "ke-wan-gong-ju-zi-you-bian-ji-qi/zuo-pin-zhi-zuo-zhong-yao-ti-shi") : getRouteHelperUrlByDomain("com", "playable-tools-content-editor/blank-canvas-important-notice");
            window.open(url, "_blank");
        };
        var handleClose = function() {
            emit("update:visible", false);
        };
        var handleSubmit = function() {
            emit("handlePsEdit");
            handleClose();
        };
        return {
            PtButtonType: PtButtonType,
            PtButtonTheme: PtButtonTheme,
            dialogVisible: dialogVisible,
            handleClose: handleClose,
            handleSubmit: handleSubmit,
            handleToPage: handleToPage
        };
    }
});
